import React from "react";
import { ShieldCheck, Wallet, ThumbsUp, Headphones } from "lucide-react";

const items = [
  { icon: Wallet, label: "Payment Plans Available" },
  { icon: ThumbsUp, label: "100% Satisfaction Guarantee" },
  { icon: ShieldCheck, label: "Fully Licensed & Insured" },
  { icon: Headphones, label: "24/7 Live Answering" },
];

export default function TrustBar() {
  return (
    <section className="bg-white border-b">
      <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map(({ icon: Icon, label }) => (
          <div key={label} className="flex items-center gap-3 justify-center md:justify-start">
            <div className="w-11 h-11 rounded-full bg-sky-50 border border-sky-100 flex items-center justify-center shrink-0">
              <Icon size={20} className="text-sky-600" />
            </div>
            <div className="text-sm font-semibold text-slate-700 leading-tight">{label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
